import React from 'react';
import {Tabs, TabProps} from '@mantine/core';

export const EtroTabsTab: React.FC<TabProps> = props => {
  return <Tabs.Tab {...props} />;
};
